import styled from '@emotion/styled'

const IconContainer = styled.div<{ top?: string }>`
  position: relative;
  top: ${(props) => props.top ?? '0px'};
  z-index: 1;
`

export default IconContainer
